
<script>
    export default {
        props: ['items', 'title']
    }
</script>
<template>
    <div class="breadcrumb-area-green">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="page-banner text-center">
                        <h2 class="font-size-72">{{ title }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
